import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'
import PeopleImportTemplate from '../../../components/5templates/PeopleImportTemplate'
import { useNavigate } from 'react-router-dom'
import {useState} from 'react'
import {
    setItemToSessionStorage
} from '../../../services/util/sessionStorageManager'
import {areAllObjectValuesEmpty} from '../../../services/util/miscellaneousService'


const ImportPeopleForm = () => {
    const navigate = useNavigate()
    const [selectedContactList, setSelectedContactList] = useState({})
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false)

    const onNext = () => {
        if(!areAllObjectValuesEmpty(selectedContactList)){
            setItemToSessionStorage('newContact', selectedContactList)
            navigate('/addClient/service')
        }else{
            setIsSnackbarOpen(true)
        }
    }

    const onPrev = () => {
        setItemToSessionStorage('newContact', selectedContactList)
        navigate('/addClient/location')
    }

    return(
        <DataImportFormTabs flow={'addClient'}>
            <PeopleImportTemplate selectedContactList={selectedContactList} setSelectedContactList={setSelectedContactList}
                                  onNext={onNext} onPrev={onPrev} formCheckSnackbar={isSnackbarOpen}
                                  setFormCheckSnackbar={setIsSnackbarOpen} />
        </DataImportFormTabs>
    )
}

export default ImportPeopleForm
